import React, { useEffect } from 'react'
import Helmet from 'react-helmet'
import { Redirect } from 'react-router-dom'
import styled from 'styled-components'
import { Layout } from 'antd'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withWindowSizes } from '@edulastic/common'

// components
import Header from './Header'
import LoginContainer from './Container'
import MfaLoginLayout from './MfaLoginLayout'
import UserTokenExpiredModal from '../../../common/components/UserTokenExpiredModal'
import { Partners } from '../../../common/utils/static/partnerData'
import {
  validatePartnerUrl,
  getPartnerKeyFromUrl,
  updateMetaTag,
  removeMetaTag,
} from '../../../common/utils/helpers'
import { getMfaState } from '../ducks'

const Wrapper = styled(Layout)`
  width: 100%;
  overflow: hidden;
`

const Login = ({
  isSignupUsingDaURL,
  generalSettings,
  districtPolicy,
  orgShortName,
  orgType,
  mfa,
  windowWidth,
}) => {
  // eslint-disable-next-line
  const partnerCheck = getPartnerKeyFromUrl(location.pathname)
  const partner = Partners[partnerCheck]
  const backgroundImage = isSignupUsingDaURL
    ? generalSettings?.pageBackground || ''
    : partner.background

  useEffect(() => {
    // Check for session expiry
    const sessionExpired = sessionStorage.getItem('sessionExpired')
    if (sessionExpired === 'true') {
      window.dispatchEvent(new Event('user-token-expired'))
      sessionStorage.removeItem('sessionExpired')
    }
    // Update meta tag
    updateMetaTag({
      content:
        'Simple classroom assessments and scalable common assessments, all in one.',
    })
    return () => {
      removeMetaTag() // Removing description meta tag
    }
  }, [])

  if (mfa?.show) {
    return (
      <Wrapper>
        {!isSignupUsingDaURL && !validatePartnerUrl(partner) ? (
          <Redirect exact to="/" />
        ) : null}
        <Helmet>
          <link rel="canonical" href="https://assessment.peardeck.com/login" />
        </Helmet>
        <MfaLoginLayout
          windowWidth={windowWidth}
          isSignupUsingDaURL={isSignupUsingDaURL}
          generalSettings={generalSettings}
          backgroundImage={backgroundImage}
        />
        <UserTokenExpiredModal />
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      {!isSignupUsingDaURL && !validatePartnerUrl(partner) ? (
        <Redirect exact to="/" />
      ) : null}
      <LoginWrapper Partners={partner} image={backgroundImage}>
        <Helmet>
          <link rel="canonical" href="https://assessment.peardeck.com/login" />
        </Helmet>
        {partner.name !== 'login' && <Backdrop Partners={partner} />}
        <Header
          Partners={partner}
          isSignupUsingDaURL={isSignupUsingDaURL}
          districtPolicy={districtPolicy}
          orgShortName={orgShortName}
          orgType={orgType}
          generalSettings={generalSettings}
        />
        <LoginContainer
          Partners={partner}
          isSignupUsingDaURL={isSignupUsingDaURL}
          districtPolicy={districtPolicy}
          orgShortName={orgShortName}
          orgType={orgType}
          generalSettings={generalSettings}
        />
      </LoginWrapper>
      <UserTokenExpiredModal />
    </Wrapper>
  )
}

const enhance = compose(
  withWindowSizes,
  connect((state) => ({
    mfa: getMfaState(state),
  }))
)

export default enhance(Login)

const LoginWrapper = styled.div`
  background: ${(props) =>
    props.image
      ? `#999999 url(${props.image}) no-repeat fixed top center`
      : '#067059'};
  background-size: cover;
  margin: 0px;
  padding: 0px;
  min-height: 100vh;
  height: 100%;
  width: 100%;
`

const Backdrop = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background: rgba(0, 0, 0, ${(props) => props.Partners.opacity});
`
